import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

if (import.meta.env.DEV) {
  import("@/config/adSlots").then(({ HAS_PLACEHOLDER_SLOTS, PLACEHOLDER_SLOT_NAMES }) => {
    if (!HAS_PLACEHOLDER_SLOTS) return;
    console.warn(
      "%c[Marstick AdSense] Placeholder slot IDs detected.\n" +
        "Ads will not fill until real IDs are pasted into src/config/adSlots.js.\n" +
        "Visit AdSense → Ads → By ad unit to create them.\n" +
        "Affected slots: " + PLACEHOLDER_SLOT_NAMES.join(", "),
      "color: #f87171; font-weight: bold;"
    );
  });
}

// styles
import "@/index.css";
import "@/styles/rtl.css";

const shouldUsePwaServiceWorker =
  import.meta.env.PROD &&
  ["marstick.com", "www.marstick.com"].includes(window.location.hostname) &&
  window.location.protocol === "https:";

const clearServiceWorkerCaches = async () => {
  const registrations = await navigator.serviceWorker?.getRegistrations?.();
  await Promise.all((registrations || []).map((registration) => registration.unregister()));
  if ("caches" in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map((key) => caches.delete(key)));
  }
};

if (!shouldUsePwaServiceWorker && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    clearServiceWorkerCaches().then(() => {
      if (navigator.serviceWorker.controller && sessionStorage.getItem("marstick_sw_dev_reload") !== "true") {
        sessionStorage.setItem("marstick_sw_dev_reload", "true");
        window.location.reload();
      }
    });
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


// PWA service worker registration (production custom domain only; safe no-op if unsupported)
if (shouldUsePwaServiceWorker && "serviceWorker" in navigator) {
  window.addEventListener("load", function () {
    navigator.serviceWorker.register("/sw.js").then(function (registration) {
      registration.addEventListener("updatefound", function () {
        const worker = registration.installing;
        if (!worker) return;
        worker.addEventListener("statechange", function () {
          if (worker.state !== "installed" || !navigator.serviceWorker.controller) return;
          window.dispatchEvent(new CustomEvent("marstick:pwa-update-ready"));
        });
      });
    }).catch(function (err) {
      // Non-fatal: app works without SW. Log for diagnostics only.
      console.warn("Service worker registration failed:", err);
    });
  });
}